import React from "react";
import BillingInformation from "./BillingInformation";
import { states } from "../StateManagement";
interface IProps {
    displayData: any;
    manage: any;
    registrationState: any;
    setRegistrationState: any;
    registrationLookup?: any;
}
const Billing = ({ displayData, manage, registrationState, setRegistrationState, registrationLookup }: IProps) => {
    return (
        <div className="row" id="content">
            <div className="col-xs">
                {states[1].errMsg && (
                    <div className="notice-container status-warning notice-xl" role="alert" aria-atomic="true">
                        <span role="img" aria-label="info-circle" className="notice-icon">
                            <em className="las la-exclamation-circle"></em>
                        </span>
                        <div className="notice-message">Please review the following error(s):</div>
                        <div className="notice-description">{states[1].errMsg}</div>
                    </div>
                )}
                <div className="box box-has-shadow offset-padding">
                    <BillingInformation
                        registrationLookup={registrationLookup}
                        manageState={manage}
                        displayData={displayData}
                        registrationState={registrationState}
                        setRegistrationState={setRegistrationState}
                    />
                </div>
            </div>
        </div>
    );
};

export default Billing;
